import React, { useMemo } from "react";
import type { ICellRendererParams } from "ag-grid-community";
import type { IRowData } from "components/shipment-review/types";
import _ from "lodash";
import { makeStyles } from "@material-ui/core/styles";
import classNames from "classnames";
import theme from "styles/theme";

interface IProps extends CastProp<ICellRendererParams, "data", IRowData> {}

export const DbpDeliveryCellRenderer = (props: IProps) => {
    const prices = useMemo<string>(
        () => (props.data.dbpPrices?.prices ?? []).join(" - "),
        [props.data.dbpPrices?.prices]
    );
    const classes = useStyles();
    return (
        <div>
            <div>{props.value}</div>
            {!_.isEmpty(prices) && (
                <div className={classNames(classes.price, props.data.dbpPrices?.discount && classes.priceDiscounted)}>
                    {prices}
                </div>
            )}
        </div>
    );
};

const useStyles = makeStyles({
    price: {
        color: theme.palette.darkGrey,
        lineHeight: "12px",
        fontSize: "10px",
        fontWeight: "normal",
    },
    priceDiscounted: {
        color: "green",
    },
});
